module.exports = __webpack_public_path__ + "static/media/claro-club.svg:Zone.7a821669.Identifier";